module.exports = __webpack_public_path__ + "static/plumber-063f0fa610ddf7af3000f7455ee5c70b.png";